import TermsOfServicePixelTracker from './TermsOfServicePixelTracker';
export default TermsOfServicePixelTracker;
